// Authors extension (admin side): who made the product.
// The tab is the old catalog editor's AuthorsTab, reused as it is — it reads and
// writes through the shared catalog editor (../shared/catalog-editor.jsx).
import { UsersIcon } from "@heroicons/react/24/outline"
import AuthorsTab from "./AuthorsTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "authors",
  label: "Authors",
  description: "Author, translator, illustrator and narrator of the product",
  section: {
    component: catalogSection(AuthorsTab),
    label: "Authors",
    icon: UsersIcon,
    order: 200,
    visible: catalogVisible("authors"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
